import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    load: 'languageOnly',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    defaultNS: 'common',
    ns: ['common'],
    detection: {
      // No 'navigator' fallback — we want English by default even for
      // German browsers. Users can still toggle to DE via the language button,
      // and their choice is persisted in localStorage.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
